class SectionSignUp implements ng.IComponentController {
    bgTopColor: 'gray' | 'white' = this.bgTopColor || 'gray';
    ltTitle: string = this.ltTitle || 'start-creating-now';

    buttons: anm.LandingButtonData[] | boolean = this.buttons || true;
}

angular.module('animatronApp.sectionSignUp', []).component('sectionSignUp', {
    bindings: {
        ltTitle: '<?',
        buttons: '<?',
        bgTopColor: '<?',
    },
    controller: SectionSignUp,
    templateUrl: require('landing-template/components/sections/section-sign-up.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionSignUp.ts